import React from 'react';

import type { CommentType } from '../../types/comments';
import { BlackCommentCard } from './BlackCommentCard';

export const EarliestCommentCard = React.memo(function EarliestCommentCard({
  comment,
  audience = false,
}: {
  comment: Omit<CommentType, 'isEggWinner'>;
  audience?: boolean;
}) {
  const datePurchased = new Date(comment.updatedAt ?? 0);
  const isForNewWaveform = !audience;

  return (
    <BlackCommentCard
      username={comment.username}
      publicAddress={comment.publicAddress}
      comment={comment.commentText}
      commentTimestamp={comment.commentTimestamp}
      datePurchased={datePurchased}
      avatarUrl={comment.avatarUrl}
      isArtist={comment.isArtist}
      webappUri={comment.webappUri}
      audience={audience}
      totalEditions={isForNewWaveform ? comment.ownerReleaseNftCount : undefined}
    />
  );
});
